export function RestaurantInfoFactory($http, $q) {
    'ngInject';

    const info = {
        general: null,
        restaurantAddress: null,
        imageSet: null,
        schedules: null,
        deliveryInfo: null,
        diningOptions: null,
        onlineOrder: null,
        prepTimes: null,
        managementGroupGuid: null,
        features: null
    };

    const serverRenderedInfoSetDFD = $q.defer();
    const promises = {};

    /**
     *
     * @param {Array<string>} parametersToInclude
     * @returns {Promise<object>}
     */
    const getInfo = function(parametersToInclude) {
        if (!parametersToInclude) {
            return $q.reject('No parameters were specified.');
        }

        return serverRenderedInfoSetDFD.promise.then(() => {
            // Find what we need to spin off a new request for.
            const parametersToRequest = parametersToInclude
                .filter(param => info[param] === null && !promises[param]);

            if (parametersToRequest.length) {
                const promise = $http({
                    url: 'info',
                    method: 'GET',
                    params: {
                        include: parametersToRequest.join(',')
                    }
                }).then(response => {
                    setInfo(response.data);
                });

                parametersToRequest.forEach(param => {
                    promises[param] = promise;
                });
            }

            // Wait on any new request we just spun off plus whatever existing requests
            // were in progress.
            return $q.all(parametersToInclude.map(param => promises[param]))
                .then(() => info);
        });
    };

    const setServerRenderedInfo = data => {
        setInfo(data);
        serverRenderedInfoSetDFD.resolve();
    };

    /**
     * n.b. for tests, be sure to call `setServerRenderedInfo()` if necessary
     * or else `getInfo()`'s promise will never resolve.
     */
    const setInfo = function(data) {
        // We have to ensure that we explicitly mark each type of restaurant info as resolved
        // if this is called from setServerRenderedInfo(). If called from getInfo(), promises[key]
        // will already be set to the promise from the $http call, which has resolved by this point
        // and is safe to replace with a new, pre-resolved promise.
        Object.keys(data)
            .forEach(key => promises[key] = $q.resolve());

        Object.assign(info, data);
    };

    return {
        getInfo,
        setInfo,
        setServerRenderedInfo
    };
}
